.ux-iws-hot-spot-container {
    display: block;
    margin-bottom: 60px;
}

.ux-iws-hot-spot-container__hot-spot-area {
    display: block;
    position: relative;

    ux-iws-hot-spot {
        position: absolute;
    }
}

.ux-iws-hot-spot-container__info-box__container {
    position: relative;
    margin-top: -20px;
    pointer-events: none;

    @media screen and (min-width: 568px) {
        margin-top: -60px;
    }

    @media screen and (min-width: 1024px) {
        margin-top: -150px;
    }
}

.ux-iws-hot-spot-container__info-box__outer {
    padding: 30px 15px;
    position: relative;
    background: #fff;
    box-shadow: 0 30px 50px -30px rgba(0, 0, 0, 0.4);

    @media (min-width: 568px) {
        padding: 30px 50px;
    }

    @media (min-width: 1024px) {
        padding: 50px 100px;
    }
}

.ux-iws-hot-spot-container__info-box__inner {
    position: relative;
}

.ux-iws-hot-spot-container__info-box__inner h2 {
    font-family: "Frutiger-Bold", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    padding: 0;
    margin: 0;
    font-size: 20px;
}
